import { Routes } from '@angular/router';

// layouts
import { AppLayout } from './layouts/layout/app-layout';
import { AuthLayout } from './layouts/auth-layout/auth-layout';

// pages
import { KnowledgeBaseComponent } from './pages/knowledge-base';
import { FaqComponent } from './pages/faq';
import { AuthGuard } from './auth/guards/auth.guard';
import { Error404Component } from './pages/error404';

export const routes: Routes = [
    // Rotas públicas (sem autenticação)
    {
        path: 'registro/sindico',
        loadComponent: () => import('./views/public/register/register.component').then(m => m.PublicRegisterComponent),
        data: { title: 'Cadastro de Síndico' },
    },
    {
        path: 'registro/morador',
        loadComponent: () => import('./views/public/register/register.component').then(m => m.PublicRegisterComponent),
        data: { title: 'Cadastro de Morador' },
    },

    {
        path: '',
        component: AppLayout,
        canActivate: [AuthGuard],
        children: [
            // dashboard
            {
                path: '',
                loadChildren: () => import('./views/views.module').then(m => m.ViewsModule),
            },
           ],
    },

    {
        path: '',
        component: AuthLayout,
        children: [
            // pages
            { path: '', loadChildren: () => import('./pages/pages.module').then(d => d.PagesModule) },

            // auth
            { path: '', loadChildren: () => import('./auth/auth.module').then(d => d.AuthModule) },
        ],
    },
    // Rota wildcard para capturar URLs não encontradas
    {
        path: '**',
        loadComponent: () => import('./views/errors/error404').then(m => m.Error404Component),
    },
];
